import { CreateQueryFreezeState } from 'stores/interfaces/CreateQueryState';
import { SetState } from 'zustand';

export const createQueryEditabilityInitialState: Omit<CreateQueryFreezeState, 'unfreeze'> = {
  editParam: false,
  // *** Base Query ***
  sourceText: false,
  // *** Common Values ***
  xtmProjectName: false,
  fileName: false,
  sourceContact: false,
  // *** Dita ***
  // xtmProjectName: false,
  fileTitle: false,
  // fileName: false,
  loio: false,
  deliverable: false,
  cmsProject: false,
  // sourceContact: false,
  submap: false,
  // *** UI/UA ***
  // xtmProjectName: false,
  repository: false,
  collection: false,
  // fileName: false,
  stringId: false,
  // sourceContact: false,
  // *** Training ***
  // xtmProjectName: false,
  // fileName: false,
  // *** Corporate Contact ***
  // xtmProjectName: false,
  // fileName: false,
  // *** ABAP ***
  system: false,
  objectType: false,
  objectName: false,
  objectOwner: false,
  collectionPackage: false,
  collectionOwner: false,
  applicationComponent: false,
  repositoryProgramType: false,
  repositoryProgramId: false,
  repositoryProgramName: false,
  translationArea: false,
  maxLength: false,
  // *** Notes ***
  documentNumber: false,
  component: false,
  worklist: false,
  documentResponsible: false,
  // *** Marketing ***
  // fileName: false,
  account: false
};

export const createQueryFreezeSlice = (set: SetState<CreateQueryFreezeState>) => ({
  ...createQueryEditabilityInitialState,
  setEditParam: (value: boolean) => set(() => ({ editParam: value })),
  setSourceText: (value: boolean) => set(() => ({ sourceText: value })),
  setXtmProjectName: (value: boolean) => set(() => ({ xtmProjectName: value })),
  setFileName: (value: boolean) => set(() => ({ fileName: value })),
  setSourceContact: (value: boolean) => set(() => ({ sourceContact: value })),
  setFileTitle: (value: boolean) => set(() => ({ fileTitle: value })),
  setLoio: (value: boolean) => set(() => ({ loio: value })),
  setDeliverable: (value: boolean) => set(() => ({ deliverable: value })),
  setCmsProject: (value: boolean) => set(() => ({ cmsProject: value })),
  setSubmap: (value: boolean) => set(() => ({ submap: value })),
  setRepository: (value: boolean) => set(() => ({ repository: value })),
  setCollection: (value: boolean) => set(() => ({ collection: value })),
  setStringId: (value: boolean) => set(() => ({ stringId: value })),
  setSystem: (value: boolean) => set(() => ({ system: value })),
  setObjectType: (value: boolean) => set(() => ({ objectType: value })),
  setObjectName: (value: boolean) => set(() => ({ objectName: value })),
  setObjectOwner: (value: boolean) => set(() => ({ objectOwner: value })),
  setCollectionPackage: (value: boolean) => set(() => ({ collectionPackage: value })),
  setCollectionOwner: (value: boolean) => set(() => ({ collectionOwner: value })),
  setApplicationComponent: (value: boolean) => set(() => ({ applicationComponent: value })),
  setRepositoryProgramType: (value: boolean) => set(() => ({ repositoryProgramType: value })),
  setRepositoryProgramId: (value: boolean) => set(() => ({ repositoryProgramId: value })),
  setRepositoryProgramName: (value: boolean) => set(() => ({ repositoryProgramName: value })),
  setTranslationArea: (value: boolean) => set(() => ({ translationArea: value })),
  setMaxLength: (value: boolean) => set(() => ({ maxLength: value })),
  setDocumentNumber: (value: boolean) => set(() => ({ documentNumber: value })),
  setComponent: (value: boolean) => set(() => ({ component: value })),
  setWorklist: (value: boolean) => set(() => ({ worklist: value })),
  setDocumentResponsible: (value: boolean) => set(() => ({ documentResponsible: value })),
  setAccount: (value: boolean) => set(() => ({ account: value })),
  unfreeze: () => set(() => ({ ...createQueryEditabilityInitialState }))
});
